module.exports = __webpack_public_path__ + "static/media/10n.e734694c.png";